import { Component, OnInit, ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-biddingmanagement',
  templateUrl: './biddingmanagement.component.html',
  styleUrls: ['./biddingmanagement.component.css']
})
export class BiddingmanagementComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns = ['productId', 'productDetails.productName', 'productImage','accountDetails.emailAddress', 'requiredQuantity', 'counterOfferPrice', 'statusOfBiddingRequest']
  dataSource: any;
  tableData: any;
  userDetails: any;
  productImageId: any;
  myurl: string;
  showFilter: boolean;
  showCustomisedSearch: boolean;
  filterValueSelected: string;
  searchValue: string;
  constructor(private cs: CucurachaAdminService,private excelService: ExcelService) {
    this.myurl = this.cs.endpoint;

   }
   filter() {
    this.getBiddingDetails()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getBiddingDetails();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForBiddingDetails(this.filterValueSelected, filterValue).subscribe((data) => {
        this.dataSource = new MatTableDataSource(data.result)

      })
    }
    else {
      this.getBiddingDetails()
    }
  }
  viewImages(id:any){
    this.productImageId=id
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    this.excelService.exportAsExcelFile(this.tableData, 'Bidding Details');
    this.cs.exportLogAdd(this.userDetails.emailId,'Bidding Details').subscribe((data) => {
    })
  }
  ngOnInit(): void {
    this.getBiddingDetails();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
 
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
    })
  }
  userSessionData(userSessionData: any) {
    throw new Error('Method not implemented.');
  }
  getBiddingDetails() {
    this.cs.getBiddingDetails().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data.result);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
}
